module.exports = __webpack_public_path__ + "img/hifu_c4ambw_c_scale,w_1400.98a30c6a.jpg";